import { render } from "./ChartPolar.vue?vue&type=template&id=6d15df89"
import script from "./ChartPolar.vue?vue&type=script&lang=js"
export * from "./ChartPolar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Advanced/ChartPolar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d15df89"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d15df89', __exports__)) {
    api.reload('6d15df89', __exports__)
  }
  
  module.hot.accept("./ChartPolar.vue?vue&type=template&id=6d15df89", () => {
    api.rerender('6d15df89', render)
  })

}


export default __exports__